import { useContext } from 'react';
import { LanguageContext, LanguageContextType } from '../context/LanguageContext';
import { translations } from '../translations';

// Safe fallback used when the hook is read before LanguageProvider mounts
// or during a Vite HMR boundary swap of the context module. Prevents the
// app from blank-screening on `useLanguage must be used within a LanguageProvider`.
const fallback: LanguageContextType = {
  language: 'english',
  setLanguage: () => {},
  showLanguageDialog: false,
  setShowLanguageDialog: () => {},
  showWelcomeDialog: false,
  setShowWelcomeDialog: () => {},
  t: translations.english as LanguageContextType['t'],
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  return context ?? fallback;
};
